module.exports = __webpack_public_path__ + "static/media/success-image.b716bdc3.png";